import { ServiceGroup, ServiceItem } from 'orderme-api-integration-client';
import { ITracker } from '../tracker';
import { apiKey, imagesUri } from '../../helpers/clientConfigs';
import { isMarketingCookiesAccepted } from '../../helpers/cookiesConsentStorage';

export class MetaPixelTracker implements ITracker {
  public identifyContact(): void {
    // Meta Pixel does not support contact identification without Advanced Matching
  }

  public trackPage(): void {
    try {
      if (!this.canTrack()) {
        return;
      }

      window.fbq('track', 'PageView');
    } catch (error) {
      console.error('MetaPixelTracker: Error tracking page view:', error);
    }
  }

  public viewedProductsGroup(serviceGroup: ServiceGroup, productUrl: string): void {
    try {
      if (!this.canTrack()) {
        return;
      }

      const imageUrl = serviceGroup.logoId
        ? `${imagesUri}/${serviceGroup.logoId}?orderme-api-key=${apiKey}`
        : undefined;
      window.fbq('track', 'ViewContent', {
        content_ids: [serviceGroup.id],
        content_name: serviceGroup.name,
        content_type: 'product_group',
        content_category: serviceGroup.name,
        link: productUrl,
        ...(imageUrl && { image_url: imageUrl }),
      });
    } catch (error) {
      console.error('MetaPixelTracker: Error tracking product group view:', error);
    }
  }

  public viewedProduct(serviceItem: ServiceItem, productUrl: string): void {
    try {
      if (!this.canTrack()) {
        return;
      }

      const imageUrl = serviceItem.logoId ? `${imagesUri}/${serviceItem.logoId}?orderme-api-key=${apiKey}` : undefined;

      window.fbq('track', 'ViewContent', {
        content_ids: [serviceItem.id],
        content_name: serviceItem.name,
        content_type: 'product',
        link: productUrl,
        ...(imageUrl && { image_url: imageUrl }),
      });
    } catch (error) {
      console.error('MetaPixelTracker: Error tracking product view:', error);
    }
  }

  public startedCheckout(): void {
    // Don't need to track
  }

  public canTrack(): boolean {
    if (!window.fbq) {
      return false;
    }

    return isMarketingCookiesAccepted();
  }
}
